import { useState } from "react";
import { Card, Input, Modal, notification, Button } from "antd";
import { marcarAsistenciaIngresante, consultaEncuesta } from "../../api/sistema";
import { useAuth } from "../../utils/useAuth";
// import { Link } from "react-router-dom";
// import { QrcodeOutlined } from "@ant-design/icons";
import RIngresante from "../../components/Responder/RIngresante";

const { Search } = Input;

function AsistenciaParticipante() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isConsulting, setIsConsulting] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const { usuario } = useAuth();

  const handleSearch = async (value) => {
    if (!value.length) return null;

    setIsConsulting(true);

    const body = {
      dniregistrador: usuario.nrodocumento || "not found",
      codigoOrDNI: value
    };

    await marcarAsistenciaIngresante(body)
      .then(async (res) => {
        const res2 = await consultaEncuesta(body.codigoOrDNI);
        console.log(res2.length > 0);
        if (res2.length > 0) res.payload.encuesta = true || false;

        setIsModalVisible(true);
        setModalContent(<RIngresante response={res.payload} />);
      })
      .catch((err) => {
        notification.error({ description: err.message });
      })
      .finally(() => {
        setIsConsulting(false);
        setSearchValue("");
      });
  };

  return (
    <div className="p-4 mx-auto text-center w-full">
      <div className="w-full">
        <Card className="mt-8 px-2 rounded-lg max-w-sm mx-auto">
          <div className="font-semibold flex flex-col">
            <span className="mb-2 text-base">
              Marcar asistencia por DNI de
              <span className="text-blue-400 font-bold"> INGRESANTE</span>
            </span>
            <Search
              placeholder="ejem. 789456123"
              className="text-2xl"
              type="number"
              value={searchValue}
              onSearch={handleSearch}
              onChange={(e) => setSearchValue(e.target.value)}
              enterButton
              loading={isConsulting}
              allowClear
              size="large"
            />
          </div>
        </Card>

        {/* <Link to="/sistema/qr/ingresante">
          <Button type="link" icon={<QrcodeOutlined />} size="middle" className="my-10">
            Marcar mediante código QR
          </Button>
        </Link> */}
      </div>

      <Modal
        visible={isModalVisible}
        closable
        onCancel={() => setIsModalVisible(false)}
        destroyOnClose
        footer={
          <Button onClick={() => setIsModalVisible(false)} block type="primary">
            Cerrar
          </Button>
        }
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </div>
  );
}
export default AsistenciaParticipante;
